<template>
  <div class="page">
    <van-nav-bar title="品牌战略方向" left-arrow @click-left="$router.back()"/>
    <van-form @submit="save">
      <van-field v-model="form.title" label="主题" placeholder="本月品牌重点" required/>
      <van-field v-model="form.directionText" type="textarea" rows="4" label="方向要求" placeholder="明确受众、核心主张和不能触碰的边界" required/>
      <van-field v-model="form.platform" label="重点平台"/>
      <van-field v-model="form.expectedResult" label="预期结果" placeholder="用可核验的结果描述"/>
      <van-field v-model="form.period" label="月份" placeholder="YYYY-MM"/>
      <div class="action">
        <van-button block type="primary" native-type="submit" :loading="saving">发布方向</van-button>
      </div>
    </van-form>
    <section><h2>已发布要求</h2>
      <van-cell v-for="item in items" :key="field(item,'id')" :title="field(item,'title')" :label="field(item,'direction_text')"/>
    </section>
  </div>
</template>
<script>import api from "@/api/brand";

export default {
  data() {
    return {
      saving: false,
      items: [],
      form: {requirementType: "BOSS", title: "", directionText: "", platform: "", expectedResult: "", period: new Date().toISOString().slice(0, 7)}
    }
  }, created() {
    this.load()
  }, methods: {
    field(r, k) {
      return r[k] !== undefined ? r[k] : r[k.toUpperCase()]
    }, async load() {
      try {
        this.items = await api.requirements()
      } catch (e) {
        this.$toast.fail(e.message)
      }
    }, async save() {
      this.saving = true;
      try {
        await api.saveRequirement(this.form);
        this.$toast.success("品牌方向已发布");
        this.form.title = "";
        this.form.directionText = "";
        await this.load()
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.saving = false
      }
    }
  }
};</script>
<style lang="less" scoped>
@import "./brand-page.less";

section {
  padding-bottom: .08rem
}

section /deep/ .van-cell__title {
  font-weight: 600
}

section /deep/ .van-cell__label {
  margin-top: .08rem;
  color: #777b8e;
  line-height: 1.55
}
</style>



// WEBPACK FOOTER //
// src/views/brand/BossDirection.vue